import { Routes } from '@angular/router';
import { FileSharingComponent } from './file-sharing.component';
import { CreateFileSharingComponent } from './create-file-sharing/create-file-sharing.component';
import { FileSharingDetailsComponent } from './file-sharing-details/file-sharing-details.component';

export const FILE_SHARING_ROUTES: Routes = [
  {
    path: 'file-sharing',
    component: FileSharingComponent,
  },
  {
    path: 'file-sharing/create',
    component: CreateFileSharingComponent,
  },
  {
    path: 'file-sharing/:id/details',
    component: FileSharingDetailsComponent,
  },
];
